import React from "react";
import styles from "./Navbar.module.css";
import { NavLink } from "react-router-dom";

export default function Navbar() {
  const isActive = ({ isActive }) => {
    return {
      textShadow: isActive
        ? "2px 2px 0 var(--light-purple), 0 0 1rem var(--extra-light-blue)"
        : "none",
      fontWeight: isActive ? 600 : 400,
    };
  };

  // collapse the bootstrap navbar on navlink click (mobile UX)
  const handleNavLinkClick = () => {
    const collapseEl = document.getElementById("navbarCollapse");
    if (!collapseEl) return;
    // If Bootstrap's JS is available, use its Collapse API to hide
    try {
      // global bootstrap (from bootstrap.bundle) if available
      if (window.bootstrap && window.bootstrap.Collapse) {
        const inst = window.bootstrap.Collapse.getInstance(collapseEl) || new window.bootstrap.Collapse(collapseEl, { toggle: false });
        inst.hide();
        return;
      }
    } catch (e) {
      // fallthrough to manual hide
    }

    // Fallback: manually remove show class and update toggler
    if (collapseEl.classList.contains("show")) {
      collapseEl.classList.remove("show");
      collapseEl.classList.add("collapse");
      const togg = document.querySelector(".navbar-toggler");
      if (togg) {
        togg.classList.add("collapsed");
        togg.setAttribute("aria-expanded", "false");
      }
    }
    // After collapsing the menu on mobile, smoothly scroll to the top
    // with a subtle easing animation so the page lands at the very top
    // (avoids landing in the middle/bottom on some devices).
    const scrollToTopAnimated = () => {
      if (typeof window === "undefined") return;
      // only run on small screens (mobile)
      if (!window.matchMedia("(max-width: 768px)").matches) return;

      // prefer native smooth scrolling
      try {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (e) {
        // fallback: JS animation
        const start = window.scrollY || window.pageYOffset || 0;
        const duration = 500;
        const startTime = performance.now();
        const step = (now) => {
          const elapsed = now - startTime;
          const t = Math.min(elapsed / duration, 1);
          // easeOutCubic
          const ease = 1 - Math.pow(1 - t, 3);
          window.scrollTo(0, Math.round(start * (1 - ease)));
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    };

    // run after a short delay so collapse animation can start first
    setTimeout(scrollToTopAnimated, 120);
  };

  return (
    <>
      <nav
        className={`${styles.cyberNav} navbar navbar-expand-lg justify-content-lg-center justify-content-sm-center sticky-top py-3 z-3`}
      >
        <div className="container-fluid justify-content-end">
          <button
            type="button"
            className={`${styles.menuButton} navbar-toggler border-0 collapsed`}
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className={styles.menuHint}>Tap menu</span>
            <span className={styles.menuIcon} aria-hidden="true">
              <span className={styles.menuBar}></span>
              <span className={styles.menuBar}></span>
              <span className={styles.menuBar}></span>
            </span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className={`${styles.navList} navbar-nav container p-0`}>
              <li className={`${styles.navItem} nav-item`}>
                <NavLink
                  className={`${styles.navLink} nav-link text-light font-monospace`}
                  onClick={handleNavLinkClick}
                  viewTransition
                  style={isActive}
                  to="/"
                >
                  About Hasan
                </NavLink>
                <span className={styles.navLine} aria-hidden="true"></span>
              </li>
              {/* <li className="nav-item">
                <NavLink
                  className="nav-link text-light font-monospace"
                  viewTransition
                  style={isActive}
                  to="Projects"
                >
                  Projects
                </NavLink>
              </li> */}
              <li className={`${styles.navItem} nav-item`}>
                <NavLink
                  className={`${styles.navLink} nav-link text-light font-monospace`}
                  onClick={handleNavLinkClick}
                  viewTransition
                  style={isActive}
                  to="Education"
                >
                  Education
                </NavLink>
                <span className={styles.navLine} aria-hidden="true"></span>
              </li>
              <li className={`${styles.navItem} nav-item`}>
                <NavLink
                  className={`${styles.navLink} nav-link text-light font-monospace`}
                  onClick={handleNavLinkClick}
                  viewTransition
                  style={isActive}
                  to="Work"
                >
                  Work Experience
                </NavLink>
                <span className={styles.navLine} aria-hidden="true"></span>
              </li>
              <li className={`${styles.navItem} nav-item`}>
                <NavLink
                  className={`${styles.navLink} nav-link text-light font-monospace`}
                  onClick={handleNavLinkClick}
                  viewTransition
                  style={isActive}
                  to="ProjectsGrid"
                >
                  Projects
                </NavLink>
                <span className={styles.navLine} aria-hidden="true"></span>
              </li>
              <li className={`${styles.navItem} nav-item`}>
                <NavLink
                  className={`${styles.navLink} nav-link text-light font-monospace`}
                  onClick={handleNavLinkClick}
                  viewTransition
                  style={isActive}
                  to="MyCourse"
                >
                  My Course
                </NavLink>
                <span className={styles.navLine} aria-hidden="true"></span>
              </li>
              <li className={`${styles.navItem} nav-item`}>
                <NavLink
                  className={`${styles.navLink} nav-link text-light font-monospace`}
                  onClick={handleNavLinkClick}
                  viewTransition
                  style={isActive}
                  to="ShopifyEdge"
                >
                  Shopify Edge
                </NavLink>
                <span className={styles.navLine} aria-hidden="true"></span>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
